const mapbox_config = {
	"accessToken": "pk.eyJ1IjoibmdyaWZmaXRocy1wb3N0bWVkaWEiLCJhIjoiY2p5eWluaDR1MHoycTNpbnZhYnE1ZGJ5YyJ9.ky9G5qVIJn0gz_y7tULp6Q"
};

export default mapbox_config;